import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getUserId } from "@/helpers/common";
import { getMyProRequest, requestProFromBroker } from "@/services/plansService";

export const proRequestKey = () => ["proRequest", "mine", getUserId()];

const unwrap = (response, fallback) => {
  if (response?.errorCode !== 0) throw new Error(response?.message || fallback);
  return response.result?.request || null;
};

const settle = async (request) => {
  try {
    return await request();
  } catch (error) {
    if (error?.response?.data) return error.response.data;
    throw error;
  }
};

export const useMyProRequest = (enabled = true) =>
  useQuery({
    queryKey: proRequestKey(),
    queryFn: async () => unwrap(await settle(getMyProRequest), "Could not load your request."),
    enabled: enabled && Boolean(getUserId()),
    staleTime: 60 * 1000,
    retry: false,
  });

export const useSendProRequest = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (note) =>
      unwrap(await settle(() => requestProFromBroker(note)), "Could not send your request. Please try again."),
    onSuccess: (request) => {
      queryClient.setQueryData(proRequestKey(), request);
      options.onSuccess && options.onSuccess(request);
    },
  });
};

export const pendingRequest = (request) => (request?.status === "pending" ? request : null);
